/*
  Lullmap method quiz. Implements brand-kit/quiz.json exactly:
  - points per answer, highest total wins, ties go to the gentler method (tie_break_order)
  - runner-up is the backup
  - "route": "foundations" ends the quiz with the under-4-months result
  - "flag", "start_note" and "note" are shown on the result screen
  State is kept in sessionStorage so the result survives the email form's page reload.
*/
(function () {
  var root = document.querySelector('[data-quiz]');
  var dataEl = document.getElementById('quiz-data');
  if (!root || !dataEl) return;

  var quiz = JSON.parse(dataEl.textContent);
  var STORE = 'lullmap-quiz';
  var SLUGS = { F: 'fading', P: 'pick-up-put-down', C: 'chair', K: 'check-and-console', E: 'extinction', foundations: 'foundations' };
  var FOUNDATIONS_PAGE = 6;

  var $ = function (sel) { return root.querySelector(sel); };
  var screens = {
    intro: $('[data-quiz-intro]'),
    question: $('[data-quiz-question]'),
    result: $('[data-quiz-result]')
  };

  var state = { step: 0, answers: [] };

  function track(name, data) {
    if (window.lullmapTrack) return window.lullmapTrack(name, data);
    try {
      var result = window.Shopify && Shopify.analytics && Shopify.analytics.publish(name, data || {});
      if (result && typeof result.catch === 'function') result.catch(function () {});
    } catch (e) {}
  }

  function save() {
    try { sessionStorage.setItem(STORE, JSON.stringify(state)); } catch (e) {}
  }

  function load() {
    try { return JSON.parse(sessionStorage.getItem(STORE)); } catch (e) { return null; }
  }

  function show(name) {
    Object.keys(screens).forEach(function (key) { screens[key].hidden = key !== name; });
    if (window.lullmapMarker) window.lullmapMarker.redraw();
  }

  function focus(el) {
    if (!el) return;
    el.focus({ preventScroll: true });
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    root.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
  }

  function renderQuestion() {
    var q = quiz.questions[state.step];
    var total = quiz.questions.length;
    $('[data-quiz-step]').textContent = 'Question ' + (state.step + 1) + ' of ' + total;
    $('[data-quiz-bar]').style.width = Math.round((state.step / total) * 100) + '%';
    $('[data-quiz-text]').textContent = q.text;

    var options = $('[data-quiz-options]');
    options.innerHTML = '';
    q.options.forEach(function (option, index) {
      var button = document.createElement('button');
      button.type = 'button';
      button.className = 'quiz__option';
      button.textContent = option.label;
      button.setAttribute('aria-pressed', state.answers[state.step] === index ? 'true' : 'false');
      button.addEventListener('click', function () { answer(index); });
      options.appendChild(button);
    });

    $('[data-quiz-back]').hidden = false;
    show('question');
    focus($('[data-quiz-text]'));
  }

  function answer(index) {
    state.answers[state.step] = index;
    state.answers.length = state.step + 1;
    var option = quiz.questions[state.step].options[index];

    if (option.route) {
      finish();
      return;
    }
    if (state.step + 1 < quiz.questions.length) {
      state.step += 1;
      save();
      renderQuestion();
    } else {
      finish();
    }
  }

  function score() {
    var totals = {};
    var notes = [];
    var flags = [];
    var route = null;
    quiz.tie_break_order.forEach(function (key) { totals[key] = 0; });

    state.answers.forEach(function (optionIndex, questionIndex) {
      var option = quiz.questions[questionIndex].options[optionIndex];
      if (!option) return;
      (option.points || []).forEach(function (key) { totals[key] += 1; });
      if (option.route) route = option.route;
      if (option.flag) flags.push(option.flag);
      if (option.start_note) notes.push(option.start_note);
      if (option.note) notes.push(option.note);
    });

    // Sort by points, then by position in tie_break_order (gentler first).
    var ranked = quiz.tie_break_order.slice().sort(function (a, b) {
      if (totals[b] !== totals[a]) return totals[b] - totals[a];
      return quiz.tie_break_order.indexOf(a) - quiz.tie_break_order.indexOf(b);
    });

    return { route: route, method: ranked[0], backup: ranked[1], flags: flags, notes: notes };
  }

  function flagText(key) {
    var text = quiz.results[key] || '';
    return text.replace(/^Show on the result screen:\s*/i, '');
  }

  function dots(level, label) {
    var wrap = document.createElement('span');
    wrap.className = 'dots';
    wrap.setAttribute('role', 'img');
    wrap.setAttribute('aria-label', 'Crying level ' + level + ' of 5');
    for (var i = 1; i <= 5; i++) {
      var dot = document.createElement('span');
      dot.className = 'dots__dot' + (i <= level ? ' is-on' : '');
      wrap.appendChild(dot);
    }
    return wrap;
  }

  function renderResult(result) {
    var title = $('[data-quiz-result-title]');
    var meta = $('[data-quiz-result-meta]');
    var summary = $('[data-quiz-result-summary]');
    var startOn = $('[data-quiz-start-on]');
    var backup = $('[data-quiz-backup]');
    meta.innerHTML = '';

    var resultKey;
    if (result.route === 'foundations') {
      resultKey = 'foundations';
      title.textContent = 'Foundations first';
      summary.textContent = quiz.results.foundations;
      startOn.innerHTML = '<strong>Start on page ' + FOUNDATIONS_PAGE + '</strong><br>Part 1: Foundations, 0–4 months. Come back to the quiz once your baby is 4 months (adjusted age).';
      backup.textContent = '';
    } else {
      var method = quiz.methods[result.method];
      var second = quiz.methods[result.backup];
      resultKey = result.method;
      title.textContent = method.name;
      meta.appendChild(dots(method.crying));
      var crying = document.createElement('span');
      crying.textContent = 'Crying level ' + method.crying + ' of 5';
      meta.appendChild(crying);
      summary.textContent = method.summary;
      startOn.innerHTML = '<strong>Start on page ' + method.planner_page + '</strong><br>Do the readiness check (p. 12) and the 7-night prep week (p. 14) first.';
      backup.innerHTML = '';
      var label = document.createElement('strong');
      label.textContent = 'Your backup: ';
      backup.appendChild(label);
      backup.appendChild(document.createTextNode(second.name + ' (planner p. ' + second.planner_page + '). ' + second.summary));
    }

    var flag = $('[data-quiz-flag]');
    flag.hidden = result.flags.length === 0;
    $('[data-quiz-flag-text]').textContent = result.flags.map(flagText).join(' ');

    var notesBox = $('[data-quiz-notes]');
    var list = $('[data-quiz-notes-list]');
    list.innerHTML = '';
    result.notes.forEach(function (note) {
      var li = document.createElement('li');
      li.textContent = note;
      list.appendChild(li);
    });
    notesBox.hidden = result.notes.length === 0 || resultKey === 'foundations';

    var tags = root.querySelector('[data-quiz-tags]');
    if (tags) tags.value = 'quiz, quiz-' + SLUGS[resultKey];

    show('result');
    return resultKey;
  }

  function finish() {
    var result = score();
    state.done = true;
    save();
    var key = renderResult(result);
    track('quiz_complete', { method: SLUGS[key] });
    focus($('[data-quiz-result-title]'));
  }

  root.querySelector('[data-quiz-start]').addEventListener('click', function () {
    state = { step: 0, answers: [] };
    save();
    track('quiz_start', {});
    renderQuestion();
  });

  $('[data-quiz-back]').addEventListener('click', function () {
    if (state.step === 0) {
      show('intro');
      focus(root.querySelector('h1'));
      return;
    }
    state.step -= 1;
    save();
    renderQuestion();
  });

  $('[data-quiz-restart]').addEventListener('click', function () {
    try { sessionStorage.removeItem(STORE); } catch (e) {}
    state = { step: 0, answers: [] };
    show('intro');
    focus(root.querySelector('h1'));
  });

  // Back from the email form submit: restore the result screen.
  var saved = load();
  var posted = /customer_posted=true/.test(location.search) || root.querySelector('[data-quiz-optin-success]') || root.querySelector('.quiz__form .form-error');
  if (saved && saved.done && posted) {
    state = saved;
    renderResult(score());
    if (root.querySelector('[data-quiz-optin-success]') && !saved.optinTracked) {
      track('email_optin', { source: 'quiz' });
      state.optinTracked = true;
      save();
    }
    var email = document.getElementById('quiz-email');
    if (email) email.scrollIntoView({ block: 'center' });
  }
})();
